{#if injectors.length ===0}
<Panel flex items="start" justify="start" mb="xs" px="xs" rounded="xs">

  <Panel overflow="hidden" pb="xs" mr="xs">
    <Icon name="query" size="xl" bg="light" color="dark--" w=2.25 h=2.25 round noborder="3"/>
  </Panel>

  <Panel grow ml="sm">

    <Text nm color="body" line="ample" pb="sm">
      No hay consultas definidas para este reporte.
    </Text>
    <br>
    <Button 
      bg="light"
      color="primary++"
      border="0"
      xs bold p="sm" mt="xs"
      hover="injector-add-button-hover"
      pointer
      on:click={addInjector}
      >
      <Icon name="add" size="nm" />
      Agrega una consulta
    </Button>

  </Panel>
</Panel>
{/if}

{#each injectors as _this, index} 
  <Panel flex items="start" justify="start" mb="xs" p="xs" rounded="xs"
    hover={editing !== index ? true : null}  
    >

    <Panel overflow="hidden" pb="xs" mr="xs" w="3">
      <Icon name="query" size="xl" bg="light" color="dark--" w=2.25 h=2.25 round noborder="3"/>
    </Panel>

    {#if _this && editing !== index}
      <Panel
        grow  
        flex items="center" justify="between"
        bg={editing !== null && editing === index ? 'gray200' : null}
        >

        <Label
          on:click={() => editInjector(index)}
          sm
          color="body"
          px="sm" py="sm"
          line="normal"
          align="left"
          bg="transparent"
          border="none"
          grow
          pointer
          hover="injector-label-hover"
          >
          { _this.query.title || 'Nueva consulta'}
          &nbsp;a:
          {_this.into || '...'}
        </Label>
        
        <IconButton 
          on:click={() => deleteInjector(index)}
          name="close" 
          size="nm" 
          h=1.5 
          w=1.5 
          color="black" 
          mr="sm"
          round
          pointer
          hover="injector-delete-button-hover"
          />
      </Panel>
    {/if}

    {#if _this && editing === index}
      <Panel p="md" border-left="5">
        <QueryBuilder 
          bind:query={injectors[editing].query} 
          />
        <hr>
        Copiar a hoja 
        <Input 
          w="10"
          p="xs"
          bind:value={injectors[editing].into}
          />
        <button
          on:click={() => editing = null}
          >Ok
        </button>
      </Panel>
    {/if}

  </Panel> 
{/each}

{#if injectors.length > 0}
  <Panel pl="2.75">
    <Button 
      bg="light"
      color="primary++"
      border="0"
      xs bold p="sm"
      hover="injector-add-button-hover"
      pointer
      on:click={addInjector}
      >
      <Icon name="add" size="nm" />
      Agrega otra consulta
    </Button>
  </Panel>
{/if}


<script>
  import { tick } from 'svelte';
  import { Panel, Input, Label, Icon, Text, Button } from 'svelte-stylo'
  import { IconButton } from 'svelte-stylo-kit'
  import { QueryBuilder, Query } from '@/components'
  import { randid } from '@/helpers';

  export let injectors = [];

  let editing = null;
  let count = (injectors || []).length;

  async function editInjector(index) {
    editing = null; // force unmount !
    await tick();
    editing = index;
  }

  function addInjector() {
    count = count + 1;
    let query = Query.empty();
    query.id = randid();
    query.title = "";//"Consulta #"+count;

    injectors = injectors.concat([{
      query: query,
      into: "" 
    }]);

    editInjector(injectors.length-1);
  }

  function deleteInjector(index) {
    injectors = injectors.filter((t, k) => {
      return (k !== index);
    });

    editing = null;
  }

</script>

<style>
  :global(.injector-label-hover:hover) {
    text-decoration: underline;   
    color: red;
  }
  :global(.injector-delete-button-hover:hover) {
    border: 1px solid #222;
  }
  :global(.injector-add-button-hover:hover) {
    background-color: #fff !important;
    color: red !important;
    border: 1px solid #aaa !important;
  }
</style>
